var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { overlay as overlayStyle, sweetAlertContainer as containerStyle } from "../styles/SweetAlertStyles";
var Overlay = /** @class */ (function (_super) {
    __extends(Overlay, _super);
    function Overlay() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.overlayElement = null;
        _this.setOverlayElementRef = function (element) {
            _this.overlayElement = element;
        };
        return _this;
    }
    Overlay.prototype.componentDidMount = function () {
        if (this.overlayElement) {
            this.overlayElement.scrollTop = 0;
        }
    };
    Overlay.prototype.render = function () {
        var _a = this.props, show = _a.show, onClick = _a.onClick, onKeyDown = _a.onKeyDown, children = _a.children;
        return show ? (React.createElement("div", { ref: this.setOverlayElementRef, style: __assign({}, overlayStyle, containerStyle), onClick: function (e) { return onClick(e); }, tabIndex: 0, onKeyDown: function (e) { return onKeyDown(e); } }, children)) : (React.createElement("div", { style: containerStyle, tabIndex: 0, onKeyDown: function (e) { return onKeyDown(e); } }, children));
    };
    return Overlay;
}(React.Component));
export default Overlay;
//# sourceMappingURL=Overlay.js.map